// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/dashboard.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base styles */
body, html {
  min-height: 100%;
  margin: 0;
  padding: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  font-family: 'Roboto', sans-serif;
}

.page-header {
  text-align: center;
  margin: 20px 0;
}

.page-header h1 {
  color: rgb(88, 255, 249);
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px  1px 0 #000, 1px  1px 0 #000; /* This creates the outline effect */
  font-size: 2.5em;
  font-weight: bold;
}

/* Container for the charts */
.chart-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between; /* This will space out the items evenly */
  gap: 20px; /* Increased gap for spacing between boxes */
  padding: 20px; /* Add padding around the entire chart area */
}

/* Individual chart boxes */
.chart-box {
  flex-basis: calc(33.333% - 40px); /* Adjusted to account for padding and any margins */
  max-width: calc(33.333% - 40px);
  flex-grow: 0;
  flex-shrink: 0;
  margin-bottom: 40px; /* Increased margin between charts if they are stacked */
  height: auto;
  max-height: 400px;
  position: relative;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.1);
  -webkit-backdrop-filter: blur(100px);
          backdrop-filter: blur(100px);
  padding: 10px;
  box-sizing: border-box;
}

.chart-box canvas {
  max-width: 100%;
  max-height: 80%;
}

/* Button styles */
button {
  background: #0f3443;
  border: none;
  border-radius: 5px;
  color: #ffffff;
  padding: 12px 24px;
  margin: 5px;
  cursor: pointer;
  font-size: 1em;
  font-weight: bold;
  letter-spacing: 0.05em;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  transition: background-color 0.3s, transform 0.2s;
}

button:hover {
  background: #00b4d8;
  transform: translateY(-2px);
}

/* Chart Axes and Labels */
.chartjs-size-monitor,
.chartjs-render-monitor {
  font-family: 'Arial', sans-serif; /* Use a clear, readable font */
}

.chartjs-render-monitor .chart-labels {
  color: #ffffff; /* Use white or a light color that shows up against your background */
  font-size: 14px; /* Increase font size for readability */
}

/* Tooltips */
.chartjs-tooltip {
  background-color: rgba(0, 0, 0, 0.8); /* Ensure tooltips are readable */
  border-radius: 8px; /* Optional: round the corners for a smoother look */
  padding: 10px; /* Add some padding inside the tooltip */
  color: #ffffff;
  font-size: 12px;
}

/* Grid Lines */
.chartjs-render-monitor .chart-grid {
  color: rgba(8, 8, 8, 0.2); /* Use a subtle white for grid lines */
  border-width: 1px;
}

/* Responsive adjustments */
@media (max-width: 1024px) {
  .chart-box {
    flex-basis: calc(50% - 10px); /* Two charts per row on medium screens */
  }
}

@media (max-width: 768px) {
  .chart-box {
    flex-basis: 100%; /* One chart per row on small screens */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,yDAAmD;EACnD,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,iFAAiF,EAAE,oCAAoC;EACvH,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,eAAe;EACf,8BAA8B,EAAE,yCAAyC;EACzE,SAAS,EAAE,4CAA4C;EACvD,aAAa,EAAE,6CAA6C;AAC9D;;AAEA,2BAA2B;AAC3B;EACE,gCAAgC,EAAE,oDAAoD;EACtF,+BAA+B;EAC/B,YAAY;EACZ,cAAc;EACd,mBAAmB,EAAE,wDAAwD;EAC7E,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,oCAAoC;EACpC,oCAA4B;UAA5B,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,wCAAwC;EACxC,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,0BAA0B;AAC1B;;EAEE,gCAAgC,EAAE,+BAA+B;AACnE;;AAEA;EACE,cAAc,EAAE,qEAAqE;EACrF,eAAe,EAAE,uCAAuC;AAC1D;;AAEA,aAAa;AACb;EACE,oCAAoC,EAAE,iCAAiC;EACvE,kBAAkB,EAAE,oDAAoD;EACxE,aAAa,EAAE,wCAAwC;EACvD,cAAc;EACd,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,yBAAyB,EAAE,sCAAsC;EACjE,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE;IACE,4BAA4B,EAAE,yCAAyC;EACzE;AACF;;AAEA;EACE;IACE,gBAAgB,EAAE,uCAAuC;EAC3D;AACF","sourcesContent":["/* Base styles */\nbody, html {\n  min-height: 100%;\n  margin: 0;\n  padding: 0;\n  background-image: url('../../public/dashboard.png');\n  background-size: cover;\n  background-position: center;\n  background-attachment: fixed;\n  font-family: 'Roboto', sans-serif;\n}\n\n.page-header {\n  text-align: center;\n  margin: 20px 0;\n}\n\n.page-header h1 {\n  color: rgb(88, 255, 249);\n  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px  1px 0 #000, 1px  1px 0 #000; /* This creates the outline effect */\n  font-size: 2.5em;\n  font-weight: bold;\n}\n\n/* Container for the charts */\n.chart-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between; /* This will space out the items evenly */\n  gap: 20px; /* Increased gap for spacing between boxes */\n  padding: 20px; /* Add padding around the entire chart area */\n}\n\n/* Individual chart boxes */\n.chart-box {\n  flex-basis: calc(33.333% - 40px); /* Adjusted to account for padding and any margins */\n  max-width: calc(33.333% - 40px);\n  flex-grow: 0;\n  flex-shrink: 0;\n  margin-bottom: 40px; /* Increased margin between charts if they are stacked */\n  height: auto;\n  max-height: 400px;\n  position: relative;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(100px);\n  padding: 10px;\n  box-sizing: border-box;\n}\n\n.chart-box canvas {\n  max-width: 100%;\n  max-height: 80%;\n}\n\n/* Button styles */\nbutton {\n  background: #0f3443;\n  border: none;\n  border-radius: 5px;\n  color: #ffffff;\n  padding: 12px 24px;\n  margin: 5px;\n  cursor: pointer;\n  font-size: 1em;\n  font-weight: bold;\n  letter-spacing: 0.05em;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n  transition: background-color 0.3s, transform 0.2s;\n}\n\nbutton:hover {\n  background: #00b4d8;\n  transform: translateY(-2px);\n}\n\n/* Chart Axes and Labels */\n.chartjs-size-monitor,\n.chartjs-render-monitor {\n  font-family: 'Arial', sans-serif; /* Use a clear, readable font */\n}\n\n.chartjs-render-monitor .chart-labels {\n  color: #ffffff; /* Use white or a light color that shows up against your background */\n  font-size: 14px; /* Increase font size for readability */\n}\n\n/* Tooltips */\n.chartjs-tooltip {\n  background-color: rgba(0, 0, 0, 0.8); /* Ensure tooltips are readable */\n  border-radius: 8px; /* Optional: round the corners for a smoother look */\n  padding: 10px; /* Add some padding inside the tooltip */\n  color: #ffffff;\n  font-size: 12px;\n}\n\n/* Grid Lines */\n.chartjs-render-monitor .chart-grid {\n  color: rgba(8, 8, 8, 0.2); /* Use a subtle white for grid lines */\n  border-width: 1px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 1024px) {\n  .chart-box {\n    flex-basis: calc(50% - 10px); /* Two charts per row on medium screens */\n  }\n}\n\n@media (max-width: 768px) {\n  .chart-box {\n    flex-basis: 100%; /* One chart per row on small screens */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
